import type { AxiosResponse } from 'axios'
import type { TFunction } from 'i18next'

import { omitAll } from 'lodash/fp'
import * as qs from 'qs'
import { toast } from 'sonner'

import { client } from '@/shared/api/client'

import contentDisposition from './content-disposition'
import { toQueryString } from './location'

const systemQuery = ['selected', 'fid']

export const getFileNameFromResponse = (response: AxiosResponse<any, any>) => {
	const cd = contentDisposition(response.headers['content-disposition'])

	return cd.parameters['filename*']
		? decodeURIComponent(cd.parameters['filename*'])
		: cd.parameters['filename']
}
export const exportFile = (
	optimizationGroupId: string,
	t: TFunction,
	query?: Record<string, unknown>
) => {
	const optionQueryString = qs.stringify(omitAll(systemQuery, query), {
		arrayFormat: 'comma',
		addQueryPrefix: true,
		encodeValuesOnly: true,
	})
	downloadFile(
		`${window.location.origin}/api/v1/optimization_groups/${optimizationGroupId}/products/${optionQueryString}`,
		t
	)
}
export const exportStreamFile = (
	template: string,
	t: TFunction,
	query?: object
) => {
	const optionQueryString = toQueryString(query || {})
	downloadFile(
		`${window.location.origin}/api/v1/export/${template}/${optionQueryString}`,
		t
	)
}
export const download = (blob: Blob, name: string) => {
	const a = document.createElement('a')
	a.href = URL.createObjectURL(blob)
	a.setAttribute('download', name)
	document.body.appendChild(a)
	a.click()
}
export const downloadFile = (url: string, t: TFunction, name?: string) => {
	toast.loading(t('report_file_loading'), { id: 'export' })

	return client.instance
		.get(url, {
			responseType: 'blob',
		})
		.then((response) => {
			download(
				new Blob([response.data]),
				name ?? getFileNameFromResponse(response)
			)
			toast.success('Success', { id: 'export' })
		})
		.catch(() => {
			toast.error('Downloading failed, please try again.', { id: 'export' })
		})
}
